import React, { useEffect, useState } from 'react';
import { formatMoney, updateItem, insertDataJson } from '../../Tools/helpers';
import PaymentHistoryTable from './TableHistoryPayments';
import TablaStudentRegister from './TableStudentRegister';

const MESES = {
  enero: 0, febrero: 1, marzo: 2, abril: 3, mayo: 4, junio: 5,
  julio: 6, agosto: 7, septiembre: 8, octubre: 9, noviembre: 10, diciembre: 11,
};
const MESES_NAMES = ['enero','febrero','marzo','abril','mayo','junio','julio','agosto','septiembre','octubre','noviembre','diciembre'];

// Devuelve la clave del mes anterior en formato "MMMM YYYY" español
const getPrevMonthKey = (selectedMonth) => {
  if (!selectedMonth) return null;
  const parts = String(selectedMonth).toLowerCase().split(' ');
  if (parts.length < 2) return null;
  const monthIdx = MESES[parts[0]];
  const year = parseInt(parts[1]);
  if (monthIdx === undefined || isNaN(year)) return null;
  const d = new Date(year, monthIdx, 1);
  d.setMonth(d.getMonth() - 1);
  return `${MESES_NAMES[d.getMonth()]} ${d.getFullYear()}`;
};

const FinancialSummaryFranchise = ({
    selectedMonth,
    setSelectedMonth,
    accountStatements,
    payments,
    getPayments,
    showActions,
    setUpdateInvoiceData,
    students,
    selectedFranchise,
    reinscriptionCost = 500,
    onPayCuotas,
    onPayReinscription,
    universityID,
    getAccountStatements,
  }) =>{

  const [accountStatementTab, setAccountStatementTab] = useState('current');
  const [generatingInvoices, setGeneratingInvoices] = useState(false);
  const [historyYear, setHistoryYear] = useState(new Date().getFullYear());
  const [message, setMessage] = useState({
    status: false,
    message: "",
    label: "",
  });

  const handleGenerateInvoices = async () => {
    setGeneratingInvoices(true);
    setMessage({ status: false, message: '', label: '' });
    const send = await insertDataJson('Franchise-Invoice', { university_id: universityID });
    setGeneratingInvoices(false);
    if (send.code === 201) {
      setMessage({ status: true, message: send.message, label: 'success' });
      getAccountStatements(universityID, historyYear);
      return;
    }
    setMessage({ status: true, message: 'Error al generar facturas', label: 'error' });
  };

  const handleYearChange = (newYear) => {
    setHistoryYear(newYear);
    getAccountStatements(universityID, newYear);
  };

  const applyPayment = async (payment, statusPayment) => {
    setMessage({
      status: false,
      message: "",
      label: "",
    });


    if (!payment) {
      return;
    }

    setMessage({
      status: true,
      message: "Aplicando...",
      label: "info",
    });

    const dataStatus = {
      status: statusPayment,
      status_description: statusPayment === 0 ? "Aprobado" : "Declinado",
    };
    
    const route = "Franchise-Update-Payment";
    const send = await updateItem(`${route}/${payment.partial_payment_id}`, dataStatus);
    if (send.code === 200) {
      setMessage({
        status: true,
        message: statusPayment === 0 ? "Se ha aprobado correctamente" : "Se ha declinado",
        label: "success",
      });
      setUpdateInvoiceData(true);
      getPayments(payment.university_id);
      return;
    }
    setMessage({
      status: true,
      message: "Ha ocurrido algo, intente de nuevo",
      label: "error",
    });
  };

  return(
      <>
        {/* Pestañas de estado de cuenta */}
        <div className="flex border-b mb-4">
          <button
            className={`py-2 px-4 font-medium ${
              accountStatementTab === 'current' ? 'text-red-600 border-b-2 border-red-600' : 'text-gray-500'
            }`}
            onClick={() => setAccountStatementTab('current')}
          >
            Mes Actual
          </button>
          <button
            className={`py-2 px-4 font-medium ${
              accountStatementTab === 'retroactive' ? 'text-red-600 border-b-2 border-red-600' : 'text-gray-500'
            }`}
            onClick={() => setAccountStatementTab('retroactive')}
          >
            Retroactivo Actual
          </button>
          <button
            className={`py-2 px-4 font-medium ${
              accountStatementTab === 'history' ? 'text-red-600 border-b-2 border-red-600' : 'text-gray-500'
            }`}
            onClick={() => setAccountStatementTab('history')}
          >
            Histórico
          </button>
          <button
            className={`py-2 px-4 font-medium ${
              accountStatementTab === 'students' ? 'text-red-600 border-b-2 border-red-600' : 'text-gray-500'
            }`}
            onClick={() => setAccountStatementTab('students')}
          >
            Alumnos
          </button>
        </div>

        {/* Resumen financiero (nueva sección) */}
        {
          accountStatementTab !== 'students' ?
        <>
          <div className="bg-gray-50 rounded-lg p-4 mb-6 grid grid-cols-1 md:grid-cols-5 gap-4">
            <div className="border-r pr-4">
              <p className="text-sm text-gray-600">TOTAL</p>
              <p className="text-lg font-bold text-red-600">
                {formatMoney(accountStatements[selectedMonth]?.summary?.total_with_late_fee || 0)}
              </p>
            </div>
            <div className="border-r pr-4">
              <p className="text-sm text-gray-600">Total del mes</p>
              <p className="text-lg font-bold">
                {formatMoney((accountStatements[selectedMonth]?.summary?.total_without_retroactive || 0))}
              </p>
            </div>
            <div className="border-r pr-4">
              <p className="text-sm text-gray-600">Recargo</p>
              <p className="text-lg font-bold">
                {formatMoney((accountStatements[selectedMonth]?.summary?.late_fee_total || 0))}
              </p>
            </div>
            <div className="border-r pr-4">
              <p className="text-sm text-gray-600">Retroactivo</p>
              <p className="text-lg font-bold">
                {formatMoney((accountStatements[selectedMonth]?.summary?.retroactive || 0))}
              </p>
            </div>
            <div className="border-r pr-4">
              <p className="text-sm text-gray-600">Inscripción</p>
              <p className="text-lg font-bold">
                {formatMoney((accountStatements[selectedMonth]?.summary?.inscription || 0))}
              </p>
            </div>
          </div>
          <div className="bg-gray-50 rounded-lg p-4 mb-6 grid grid-cols-1 md:grid-cols-4 gap-4">
            <div className="border-r pr-4">
              <p className="text-sm text-gray-600">Pagado</p>
              <p className="text-lg font-bold text-red-600">
                {formatMoney(accountStatements[selectedMonth]?.summary?.paid || 0)}
              </p>
            </div>
            <div className="border-r pr-4">
              <p className="text-sm text-gray-600">Total pendiente</p>
              <p className="text-lg font-bold">
                {formatMoney((accountStatements[selectedMonth]?.summary?.remaining || 0))}
              </p>
            </div>
            <div className="border-r pr-4">
              <p className="text-sm text-gray-600">Fecha límite</p>
              <p className="text-md font-semibold">{ accountStatements[selectedMonth]?.summary?.due_date || '' }</p>
            </div>
            <div>
              <p className="text-sm text-gray-600">Estado</p>
              <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${ Number(accountStatements[selectedMonth]?.summary?.remaining) <= 0 ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`}>
                { 
                   Number(accountStatements[selectedMonth]?.summary?.remaining) <= 0 ? 'Pagado' : 'Pendiente'
                }
              </span>
            </div>
          </div>
        </>
        : null
      }

        {/* Contenido de pestañas */}
        { accountStatementTab === 'current' ?
          <div>
            {/* Tabla de cuotas por generación */}
            {accountStatements[selectedMonth]?.generations.map((generation, idx) => (
              <div key={idx} className="mb-8">
                <h4 className="text-lg font-semibold mb-2">{generation.name}</h4>
                <div className="overflow-x-auto">
                  <table className="min-w-full border text-xs">
                    <thead>
                      <tr className="bg-gray-100">
                        <th className="py-2 px-4 border text-left">CARRERAS SEDE</th>
                        <th className="py-2 px-4 border text-left">MODALIDAD</th>
                        <th className="py-2 px-4 border text-left">CANTIDAD</th>
                        <th className="py-2 px-4 border text-left">GENERACION</th>
                        <th className="py-2 px-4 border text-left">INICIO CLASES</th>
                        <th className="py-2 px-4 border text-left">CUOTA X ALUMNO</th>
                        <th className="py-2 px-4 border text-left">CUOTA MENSUAL</th>
                      </tr>
                    </thead>
                    <tbody>
                      {generation.careers.map((career, careerIdx) => (
                        <tr key={careerIdx}>
                          <td className="py-2 px-4 border">{career.name}</td>
                          <td className="py-2 px-4 border">{career.modality}</td>
                          <td className="py-2 px-4 border">{career.quantity}</td>
                          <td className="py-2 px-4 border">{career.generation}</td>
                          <td className="py-2 px-4 border">{career.start_date}</td>
                          <td className="py-2 px-4 border">{formatMoney(career.fee_per_student)}</td>
                          <td className="py-2 px-4 border">{formatMoney(career.monthly_fee)}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            ))}

            {/* Total cuotas — siempre visible */}
            {(() => {
              const summary = accountStatements[selectedMonth]?.summary || {};
              const remainingCuotas = Number(summary.remaining || 0);
              const previousDebt = accountStatements[selectedMonth]?.previous_debt === 'true';
              const cuotaMensual = Number(summary.total_without_retroactive || 0);
              const retroactivo  = Number(summary.retroactive || 0);
              const inscripcion  = Number(summary.inscription || 0);
              const recargo      = Number(summary.late_fee_total || 0);
              const hasExtras    = retroactivo > 0 || inscripcion > 0 || recargo > 0;

              return (
                <div className="mt-6 space-y-4">

                  {/* Desglose de cargos — solo si hay conceptos adicionales */}
                  {hasExtras && (
                    <div className="border rounded-lg overflow-hidden">
                      <div className="bg-gray-100 px-4 py-2">
                        <p className="text-sm font-semibold text-gray-700">Desglose de cargos del mes</p>
                      </div>
                      <table className="min-w-full text-sm">
                        <tbody>
                          <tr className="border-b">
                            <td className="px-4 py-2 text-gray-600">Cuota mensual</td>
                            <td className="px-4 py-2 text-gray-500 text-xs">
                              {summary.students_count || 0} alumnos × cuota correspondiente
                            </td>
                            <td className="px-4 py-2 text-right font-medium">{formatMoney(cuotaMensual)}</td>
                          </tr>
                          {inscripcion > 0 && (
                            <tr className="border-b">
                              <td className="px-4 py-2 text-gray-600">Inscripción</td>
                              <td className="px-4 py-2 text-gray-500 text-xs">
                                Pago único por alumnos de nuevo ingreso en este mes
                              </td>
                              <td className="px-4 py-2 text-right font-medium">{formatMoney(inscripcion)}</td>
                            </tr>
                          )}
                          {retroactivo > 0 && (
                            <tr className="border-b">
                              <td className="px-4 py-2 text-gray-600">Retroactivo</td>
                              <td className="px-4 py-2 text-gray-500 text-xs">
                                Meses no pagados por alumnos que ingresaron después del inicio del ciclo
                              </td>
                              <td className="px-4 py-2 text-right font-medium">{formatMoney(retroactivo)}</td>
                            </tr>
                          )}
                          {recargo > 0 && (
                            <tr className="border-b">
                              <td className="px-4 py-2 text-red-600">Recargo por mora</td>
                              <td className="px-4 py-2 text-gray-500 text-xs">
                                Cargo adicional por pago fuera de fecha límite
                              </td>
                              <td className="px-4 py-2 text-right font-medium text-red-600">{formatMoney(recargo)}</td>
                            </tr>
                          )}
                          <tr className="bg-gray-50">
                            <td className="px-4 py-2 font-semibold" colSpan={2}>Total del mes</td>
                            <td className="px-4 py-2 text-right font-bold text-red-600">
                              {formatMoney(Number(summary.total_with_late_fee || 0))}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  )}

                  <div className="p-4 bg-gray-50 rounded-lg border">
                    <div className="flex justify-between items-center mb-3">
                      <div>
                        <p className="text-sm text-gray-500">Total Alumnos</p>
                        <p className="font-bold text-xl text-red-600">
                          {summary.students_count || 0}
                        </p>
                      </div>
                      <div className="text-right">
                        <p className="text-sm text-gray-500">TOTAL PENDIENTE</p>
                        <p className="font-bold text-xl text-red-600">{formatMoney(remainingCuotas)}</p>
                      </div>
                    </div>
                    {previousDebt && (
                      <p className="text-xs text-red-600 mb-2">* Debe liquidar el mes anterior</p>
                    )}
                    {showActions && (
                      <button
                        className={`w-full py-2 text-white rounded text-sm font-medium
                          ${remainingCuotas <= 0 || previousDebt ? 'bg-slate-400 cursor-not-allowed' : 'bg-red-600 hover:bg-red-700'}`}
                        onClick={onPayCuotas}
                        disabled={remainingCuotas <= 0 || previousDebt}
                      >
                        <i className="fas fa-credit-card mr-2"></i>
                        {remainingCuotas <= 0 ? 'PAGADO' : 'PAGAR CUOTAS'}
                      </button>
                    )}
                  </div>
                </div>
              );
            })()}

            {/* Tabla de reinscripción + botón — visible en el mes del invoice y el mes siguiente */}
            {(() => {
              const hasCurrentReinscription = Number(accountStatements[selectedMonth]?.summary?.reinscription || 0) > 0;
              const prevKey = getPrevMonthKey(selectedMonth);
              const hasPrevReinscription = prevKey && Number(accountStatements[prevKey]?.summary?.reinscription || 0) > 0;
              const sourceKey = hasCurrentReinscription ? selectedMonth : (hasPrevReinscription ? prevKey : null);

              if (!sourceKey) return null;

              const activeStudents = students.filter(s => s.status === 'Activo');
              const totalReinscription = activeStudents.length * reinscriptionCost;
              const remainingReinscription = Number(
                accountStatements[sourceKey]?.summary?.remaining_reinscription ?? totalReinscription
              );
              const dueDateReinscription = accountStatements[sourceKey]?.summary?.due_date_reinscription;

              return (
                <div className="mt-8 border-t pt-6">
                  <h4 className="text-lg font-semibold mb-3">Reinscripción por Alumno</h4>
                  <p className="text-xs text-gray-500 mb-3">Costo por alumno: {formatMoney(reinscriptionCost)}</p>
                  <div className="overflow-x-auto">
                    <table className="min-w-full border text-xs">
                      <thead>
                        <tr className="bg-gray-100">
                          <th className="py-2 px-4 border text-left">NOMBRE</th>
                          <th className="py-2 px-4 border text-left">CURP</th>
                          <th className="py-2 px-4 border text-left">CARRERA</th>
                          <th className="py-2 px-4 border text-left">MODALIDAD</th>
                          <th className="py-2 px-4 border text-left">COSTO REINSCRIPCIÓN</th>
                        </tr>
                      </thead>
                      <tbody>
                        {activeStudents.map((student, idx) => (
                          <tr key={idx} className={idx % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
                            <td className="py-2 px-4 border">{student.name}</td>
                            <td className="py-2 px-4 border">{student.curp}</td>
                            <td className="py-2 px-4 border">{student.career}</td>
                            <td className="py-2 px-4 border">{student.mode}</td>
                            <td className="py-2 px-4 border font-medium">{formatMoney(reinscriptionCost)}</td>
                          </tr>
                        ))}
                        {activeStudents.length === 0 && (
                          <tr>
                            <td colSpan={5} className="py-4 px-4 border text-center text-gray-400">
                              Sin alumnos activos
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>

                  {/* Total y botón de pago de reinscripción */}
                  <div className="mt-4 p-4 bg-gray-50 rounded-lg border flex justify-between items-center">
                    <div className="flex gap-8">
                      <div>
                        <p className="text-sm text-gray-500">Alumnos Activos</p>
                        <p className="font-bold text-xl text-red-600">{activeStudents.length}</p>
                      </div>
                      <div>
                        <p className="text-sm text-gray-500">TOTAL REINSCRIPCIÓN</p>
                        <p className="font-bold text-xl text-red-600">{formatMoney(totalReinscription)}</p>
                      </div>
                      {dueDateReinscription && (
                        <div>
                          <p className="text-sm text-gray-500">Fecha límite</p>
                          <p className="text-md font-semibold">{dueDateReinscription}</p>
                        </div>
                      )}
                    </div>
                    {showActions && (
                      <button
                        className={`px-6 py-2 text-white rounded text-sm font-medium
                          ${remainingReinscription <= 0 ? 'bg-slate-400 cursor-not-allowed' : 'bg-red-600 hover:bg-red-700'}`}
                        onClick={onPayReinscription}
                        disabled={remainingReinscription <= 0}
                      >
                        <i className="fas fa-credit-card mr-2"></i>
                        {remainingReinscription <= 0 ? 'PAGADO' : 'PAGAR REINSCRIPCIÓN'}
                      </button>
                    )}
                  </div>
                </div>
              );
            })()}
          </div>
         : null
        }

        { accountStatementTab === 'retroactive' ?
          <div>
            {accountStatements[selectedMonth]?.generations.map((generation, idx) => {

            // Verificar si existe algún retroactivo > 0
            const hasRetroactive = generation.careers.some(c => c.retroactive > 0);

            // Si no hay retroactivos, no renderiza nada
            if (!hasRetroactive) return null;

            return (
              <div key={idx} className="mb-8">
                <h4 className="text-lg font-semibold mb-2">{generation.name}</h4>
                <div className="overflow-x-auto">
                  <table className="min-w-full border text-xs">
                    <thead>
                      <tr className="bg-gray-100">
                        <th className="py-2 px-4 border text-left">CARRERAS SEDE</th>
                        <th className="py-2 px-4 border text-left">MODALIDAD</th>
                        <th className="py-2 px-4 border text-left">CANTIDAD ALUM.</th>
                        <th className="py-2 px-4 border text-left">CANTIDAD MES.</th>
                        <th className="py-2 px-4 border text-left">GENERACION</th>
                        <th className="py-2 px-4 border text-left">INICIO CLASES</th>
                        <th className="py-2 px-4 border text-left">INICIO ALUMNO</th>
                        <th className="py-2 px-4 border text-left">CUOTA MENSUAL</th>
                        <th className="py-2 px-4 border text-left">RETROACTIVO</th>
                      </tr>
                    </thead>

                    <tbody>
                      {generation.careers
                        .filter(career => career.retroactive > 0)
                        .map((career, careerIdx) => (
                          <tr key={careerIdx}>
                            <td className="py-2 px-4 border">{career.name}</td>
                            <td className="py-2 px-4 border">{career.modality}</td>
                            <td className="py-2 px-4 border">{career.quantity}</td>
                            <td className="py-2 px-4 border">{career.num_month}</td>
                            <td className="py-2 px-4 border">{career.generation}</td>
                            <td className="py-2 px-4 border">{career.start_date}</td>
                            <td className="py-2 px-4 border">{career.start_date_student}</td>
                            <td className="py-2 px-4 border">{formatMoney(career.fee_per_student)}</td>
                            <td className="py-2 px-4 border">{formatMoney(career.retroactive)}</td>
                          </tr>
                        ))
                      }
                    </tbody>
                  </table>
                </div>
              </div>
            );
            })}

            <div className="mt-4 p-4 bg-gray-50 rounded-lg">
              <div className="flex justify-between items-center">
                <span className="font-semibold">TOTAL DEL MES:</span>
                <span className="font-bold text-lg text-red-600">
                  {formatMoney(accountStatements[selectedMonth]?.summary?.retroactive || 0)}
                </span>
              </div>
            </div>
          </div>
         : null
        }

        { accountStatementTab === 'history' ?
          <div>
            <div className="flex justify-between items-center mb-4">
              <div className="flex items-center gap-2">
                <h4 className="text-lg font-semibold">Histórico de Estados de Cuenta</h4>
                <div className="flex items-center gap-1 ml-4">
                  <button
                    onClick={() => handleYearChange(historyYear - 1)}
                    className="px-2 py-1 rounded border text-sm hover:bg-gray-100"
                  >
                    ‹
                  </button>
                  <span className="px-3 py-1 font-semibold text-sm">{historyYear}</span>
                  <button
                    onClick={() => handleYearChange(historyYear + 1)}
                    disabled={historyYear >= new Date().getFullYear()}
                    className="px-2 py-1 rounded border text-sm hover:bg-gray-100 disabled:opacity-30 disabled:cursor-not-allowed"
                  >
                    ›
                  </button>
                </div>
              </div>
              {showActions && (
                <button
                  onClick={handleGenerateInvoices}
                  disabled={generatingInvoices}
                  className={`px-4 py-2 text-white text-sm rounded font-medium ${generatingInvoices ? 'bg-slate-400 cursor-not-allowed' : 'bg-blue-600 hover:bg-blue-700'}`}
                >
                  <i className={`fas ${generatingInvoices ? 'fa-spinner fa-spin' : 'fa-rotate'} mr-2`}></i>
                  {generatingInvoices ? 'Generando...' : 'Generar meses faltantes'}
                </button>
              )}
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              {Object.keys(accountStatements).map((month) => (
                <div 
                  key={month}
                  className={`border rounded-lg p-4 cursor-pointer hover:bg-gray-50 ${
                    selectedMonth === month ? 'border-red-500 bg-red-50' : 'border-gray-200'
                  }`}
                  onClick={() => {
                    setSelectedMonth(month);
                    setAccountStatementTab('current');
                  }}
                >
                  <h5 className="font-medium">{month}</h5>
                  <p className="text-sm text-gray-600">
                    Total: {formatMoney(accountStatements[month].summary?.total_without_retroactive)}
                  </p>
                  <p className="text-sm text-gray-600">
                    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${  Number(accountStatements[month]?.summary?.remaining) <= 0 ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`}>
                      { Number(accountStatements[month]?.summary?.remaining) <= 0 ? 'Pagado' : 'Pendiente' }
                    </span>
                  </p>
                  <p className="text-xs text-gray-500 mt-1">
                    {accountStatements[month].generations.length} generaciones
                  </p>
                </div>
              ))}
            </div>
            <div className="grid grid-cols-1">
              <PaymentHistoryTable 
                payments = {payments} 
                showActions={showActions}
                applyPayment = {applyPayment}
                message = {message}
              />
            </div>
          </div>
        : null 
        }

        { accountStatementTab === 'students' ? 
          <div>
            <TablaStudentRegister students = {students} selectedEditStudent = {{}} edit = {showActions} />
          </div>
            : null
        }

      </>
  )
}

export default FinancialSummaryFranchise